import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { GLOBAL_NAVIGATION_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

import { ssrConfig } from '../ssrConfig.ts';

export const GLOBAL_NAVIGATION_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: GLOBAL_NAVIGATION_SEGMENT_KEY,
	ssr: ssrConfig(),
});
